import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetTableComponent } from "../Components/WidgetTableComponent";
import { PopupTableComponent } from "../Popups/PopupTableComponent";
import { LanguageString } from "../../../Model/LanguageString";

export class WidgetTableProps {
    public viewType: string;
    public title: LanguageString;

    constructor() {
        this.title = new LanguageString();
    }
}

export class WidgetTable extends WidgetBase {
    props: WidgetTableProps;

    constructor(controller: WidgetController) {
        super(controller, 2, 2);
        this.props = new WidgetTableProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.Table;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (this.props.title == null)
                this.props.title = new LanguageString();
        } else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetTableComponent({
            widget: this,
            viewType: this.props.viewType,
            title: this.props.title
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupTableComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}